import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FileDown } from "lucide-react";

export default function ExcelExport({ data = [], fileName = "ExportData" }) {
  const exportToExcel = () => {
    if (!data || data.length === 0) {
      alert("⚠️ No records to export!");
      return;
    }

    // 🔹 Create worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // 🔹 Bold header row
    const headerKeys = Object.keys(data[0]);
    headerKeys.forEach((key, index) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: index });
      if (!worksheet[cellAddress]) return;
      worksheet[cellAddress].s = {
        font: { bold: true },
        alignment: { horizontal: "center", vertical: "center" },
        fill: { fgColor: { rgb: "D9E1F2" } },
        border: {
          top: { style: "thin", color: { rgb: "999999" } },
          bottom: { style: "thin", color: { rgb: "999999" } },
          left: { style: "thin", color: { rgb: "999999" } },
          right: { style: "thin", color: { rgb: "999999" } },
        },
      };
    });

    // 🔹 Auto width
    const colWidths = headerKeys.map((key) => ({
      wch: Math.max(
        key.length,
        ...data.map((row) => (row[key] ? row[key].toString().length : 0))
      ) + 2,
    }));
    worksheet["!cols"] = colWidths;

    // 🔹 Add filter
    worksheet["!autofilter"] = {
      ref: XLSX.utils.encode_range({
        s: { r: 0, c: 0 },
        e: { r: data.length, c: headerKeys.length - 1 },
      }),
    };

    // 🔹 Workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

    // 🔹 Write and save
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
      cellStyles: true,
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `${fileName}_${new Date().toISOString().split("T")[0]}.xlsx`);
  };

  return (
    <button
      onClick={exportToExcel}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "4px",
        backgroundColor: "#2563eb",
        color: "#fff",
        border: "none",
        borderRadius: "5px",
        padding: "4px 8px",
        fontSize: "12px",
        cursor: "pointer",
      }}
    >
      <FileDown size={12} />
      <span>Export</span>
    </button>
  );
}


// import React from "react";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import { FileDown } from "lucide-react"; // optional icon

// export default function ExcelExport({ data = [], fileName = "ExportData" }) {
//   const exportToExcel = () => {
//     if (!data || data.length === 0) {
//       alert("⚠️ No records to export!");
//       return;
//     }

//     // Convert JSON data to Excel format
//     const worksheet = XLSX.utils.json_to_sheet(data);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

//     // Generate Excel file and trigger download
//     const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//     const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
//     saveAs(blob, `${fileName}_${new Date().toISOString().split("T")[0]}.xlsx`);
//   };

//   return (
//     <button onClick={exportToExcel} className="btn-attachments">
//       <FileDown size={18} />
//       <span>Export to Excel</span>
//     </button>
//   );
  
// }
